/**
 * HUMANDA Portal Storage Singleton
 * FIX-053: Cross-Portal localStorage Token Isolation
 *
 * All auth token and storage operations in the HUMANDA portal
 * should use this singleton to ensure keys are namespaced
 * under the 'humanda:' prefix.
 */

import { createPortalStorage } from '@apal/shared-utils';

export const portalStorage = createPortalStorage('humanda');
